export const starterGuideApiPaths = <const>{
    starterGuideOrganisations: 'starterGuide/organisations',
    starterGuideOrganisationSteps: 'starterGuide/organisations/:organisationId/steps',
    starterGuideOrganisationSkip: 'starterGuide/organisations/:organisationId/steps/skip',
};
